import { useMemo } from 'react'

import { useConfigurationContext } from '../context/configurationContext'
import { useMetaModelContext } from '../context/metaModelContext'
import { useNavigationParams } from '../system/useNavigationParams'
import { getApplicationViewTemplates } from './helpers'
import { useOperationsContext } from './operationsContext'

export const useApplicationViewTemplateOperations = () => {
  const { templateOperations } = useOperationsContext()
  const { layer, block } = useNavigationParams()
  const { layerTopology, blockTopology } = useMetaModelContext()
  const { viewAt } = useConfigurationContext()
  return useMemo(
    () =>
      getApplicationViewTemplates({
        templateOperations,
        layer,
        block,
        layerTopology,
        blockTopology,
        viewAt,
      }),
    [templateOperations, layer, block, layerTopology, blockTopology, viewAt],
  )
}
